import { TrackerStage } from "@/v2/entities/tracker/Tracker.model";

type TrackerStageColor = {
  bg: string;
  circle: string;
  bgOpacity: number;
  circleOpacity: number;
};

const COLORS: Record<TrackerStage, TrackerStageColor> = {
  to_do: {
    bg: "var(--gray-a8)",
    circle: "var(--gray-a8)",
    bgOpacity: 1,
    circleOpacity: 0.8,
  },
  in_progress: {
    bg: "var(--amber-a8)",
    circle: "var(--amber-a8)",
    bgOpacity: 1,
    circleOpacity: 0.8,
  },
  done: {
    bg: "var(--mint-a8)",
    circle: "var(--mint-a8)",
    bgOpacity: 1,
    circleOpacity: 0.683,
  },
  hidden: {
    bg: "var(--gray-a6)",
    circle: "var(--gray-a6)",
    bgOpacity: 1,
    circleOpacity: 0.7,
  },
};

export function TrackerStageIcon({
  stage = "done",
  width = 12,
  height = 12,
}: {
  stage?: TrackerStage;
  width?: number;
  height?: number;
}) {
  const color = COLORS[stage];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
    >
      <rect
        x="0"
        y="0"
        width="12"
        height="12"
        rx="2"
        fill={color.bg}
        fillOpacity={color.bgOpacity}
      />
    </svg>
  );
}
